/**
 * Theme loader — Plan 05-05 Task 1.
 *
 * apps/api 의 `GET /api/v1/widgets/:streamerId/theme` (Plan 05-02) 엔드포인트에서
 * theme.json 을 fetch 하고 parseTheme 으로 검증. 임의 실패 경로는 defaultTheme 으로 폴백.
 *
 * 보안 (T-05-29 Tampering):
 *   - HTTPS 전제 (prod VITE_API_BASE_URL 강제).
 *   - parseTheme Zod 가 스키마 외 필드 제거 + 잘못된 구조 → fallback.
 *   - credentials: 'omit' — OBS 쿠키 · Authorization 헤더 흘리지 않음 (theme 은 public GET).
 */
import { defaultTheme, parseTheme, type Theme } from '@loop/shared';

export async function loadTheme(streamerId: string, apiBase: string): Promise<Theme> {
  const url = `${apiBase}/api/v1/widgets/${streamerId}/theme`;
  try {
    const res = await fetch(url, { credentials: 'omit' });
    if (!res.ok) {
      console.warn(`[widget-theme] fetch ${res.status} — falling back to default`);
      return defaultTheme;
    }
    let raw: unknown;
    try {
      raw = await res.json();
    } catch (jsonErr) {
      console.warn('[widget-theme] invalid JSON response — falling back to default', jsonErr);
      return defaultTheme;
    }
    const result = parseTheme(raw, defaultTheme);
    if (!result.ok) {
      console.warn('[widget-theme] parseTheme rejected payload', result.errors);
    }
    return result.theme;
  } catch (err) {
    console.warn('[widget-theme] load error — falling back to default', err);
    return defaultTheme;
  }
}
